import PropTypes from 'prop-types'
import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"

const ApproveModal = ({ show, onDeleteClick, onCloseClick,evaluationall }) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <i
                className="mdi mdi-checkbox-marked-circle-outline success"
                style={{ fontSize: "4rem", color:"#E69138"}}
              />
              <h2>Are you sure want to Approve this team?</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-center mt-3 mx--3 mb-3">
              <button
                type="button"
                className="btn btn-primary btn-lg ms-2"
                onClick={onDeleteClick}
              >
                {evaluationall == true ? "Yes, Approve All": "Yes, Approve"}
              </button>
              <button
                type="button"
                className="btn btn-outline-primary btn-lg ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

ApproveModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default ApproveModal
